import Vue from "vue";
//import Vuetify from "vuetify";
import Vuetify from 'vuetify/lib';
import "material-design-icons-iconfont/dist/material-design-icons.css";
import "vuetify/dist/vuetify.min.css";
import "@mdi/font/css/materialdesignicons.css"; // Ensure you are using css-loader

Vue.use(Vuetify);

const opts = {
  theme: {
    dark: true, // Default to dark mode for energy dashboard aesthetic
    themes: {
      light: {
        primary: "#FFC107",
        secondary: "#00BCD4",
        accent: "#00E5FF",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FF9800",
        // Energy Dashboard specific colors (for text/icons only)
        energyCyan: "#00BCD4",
        energyAmber: "#FFC107",
        energyPurple: "#9C27B0",
        energyHeat: "#FF5722",
        // Background colors
        background: "#f5f7fa",
        surface: "#ffffff",
        cardBg: "#ffffff",
      },
      dark: {
        primary: "#FFC107",
        secondary: "#00BCD4",
        accent: "#00E5FF",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FF9800",
        // Energy Dashboard specific colors (for text/icons only)
        energyCyan: "#00BCD4",
        energyAmber: "#FFC107",
        energyPurple: "#9C27B0",
        energyHeat: "#FF5722",
        // Background colors
        background: "#0a0a0a",
        surface: "#1a1a2e",
        cardBg: "#16213e",
      },
    },
    options: {
      customProperties: true, // Enable CSS custom properties
    },
  },
  icons: {
    iconfont: "mdi",
    values: {},
  },
};

export default new Vuetify(opts);
